import { SELF_REGISTRATION_RESET_LEFT_ACTIVATION_CODES_DATE_TYPES } from "../constants/selfRegistrationResetLeftActivationCodesDateType";

function selfRegistrationResetLeftActivationCodesDateTypeToLabel(code) {
  return SELF_REGISTRATION_RESET_LEFT_ACTIVATION_CODES_DATE_TYPES[code];
}

export { selfRegistrationResetLeftActivationCodesDateTypeToLabel };
